import { AnalyticsSourceValues } from '~/lib/constants/AnalyticsSource.constants';

export enum PatientEvents {
  medicalHistorySaveChangesButtonClicked = 'Medical History Save Changes Button Clicked',
  medicalHistoryEditButtonClicked = 'Medical History Edit Button Clicked',
  addAdminEpisodeCarePlanTabButtonClicked = 'Add Admin Episode Care Plan Tab Button Clicked',
  viewAdminEpisodeCarePlanTabCardDataClicked = 'View Admin Episode Care Plan Tab Card Data Clicked',
  editAdminEpisodeCarePlanTabButtonClicked = 'Edit Admin Episode Care Plan Tab Button Clicked',
  updateAdminEpisodeButtonClicked = 'Update Admin Episode Button Clicked',
  admissionsTeamEditTeamButtonClicked = 'Admissions Team Edit Team Button Clicked',
  addAdmissionsTeamMemberButtonClicked = 'Add Admission Team Member Button Clicked',
  providerTeamEditTeamButtonClicked = 'Provider Team Edit Team Button Clicked',
  addProviderTeamMemberButtonClicked = 'Add Provider Team Member Button Clicked',
  editPatientProfileTabButtonClicked = 'Edit Patient Profile Tab Button Clicked',
  addContactProfileTabButtonClicked = 'Add Contact Profile Tab Button Clicked',
  addCoverageProfileTabButtonClicked = 'Add Coverage Profile Tab Button Clicked',
  addBillingPeriodProfileTabButtonClicked = 'Add Billing Period Profile Tab Button Clicked',
  editEquipAppSettingsProfileTabButtonClicked = 'Edit Equip App Settings Profile Tab Button Clicked',
  scheduleAppointmentPatientCalendarTabButtonClicked = 'Schedule Appointment Patient Calendar Tab Button Clicked',
  uploadDocumentDocumentsTabButtonClicked = 'Upload Document Documents Tab Button Clicked',
  startTaskTaskTabButtonClicked = 'Start Task Task Tab Button Clicked',
  completeTaskTaskTabButtonClicked = 'Complete Task Task Tab Button Clicked',
  cancelAppointmentPatientCalendarKebabMenuButtonClicked = 'Cancel Appointment Patient Calendar Tab Kebab Menu Button Clicked',
  cancelAppointmentCalendarTabKebabMenuButtonClicked = 'Cancel Appointment Calendar Tab Kebab Menu Button Clicked',
  cancelAppointmentCalendarTabModalButtonClicked = 'Cancel Appointment Calendar Tab Modal Button Clicked',
  cancelAppointmentPatientCalendarTabModalButtonClicked = 'Cancel Appointment Patient Calendar Tab Modal Button Clicked',
  openZoomPatientCalendarTabButtonClicked = 'Open Zoom Patient Calendar Tab Button Clicked',
  openZoomPatientCalendarTabModalButtonClicked = 'Open Zoom Patient Calendar Tab Modal Button Clicked',
  openZoomCalendarTabButtonClicked = 'Open Zoom Calendar Tab Button Clicked',
  openZoomCalendarTabModalButtonClicked = 'Open Zoom Calendar Tab Modal Button Clicked',
  addAdmissionsTeamMemberCarePlanTabButtonClicked = 'Add Admission Team Member Care Plan Tab Button Clicked',
  editAdmissionsTeamCarePlanTabButtonClicked = 'Edit Admissions Team Care Plan Tab Button Clicked',
  editProviderTeamCarePlanTabButtonClicked = 'Edit Provider Team Care Plan Tab Button Clicked',
  saveChangesProviderTeamCarePlanTabButtonClicked = 'Save Changes Provider Team Care Plan Tab Button Clicked',
  uniqueTaskTasksTabButtonClicked = 'Unique Task Tasks Tab Button Clicked',
  orderLabLabsTabButtonClicked = 'Order Lab Labs Tab Button Clicked',

  providerAssignmentSaveChangesButtonClicked = 'Provider Assignment Save Changes Button Clicked',
  providerAssignmentCancelButtonClicked = 'Provider Assignment Cancel Button Clicked',
  providerAssignmentTemporaryCheckboxClicked = 'Provider Assignment Temporary Checkbox Clicked',
  providerAssignmentSearchForProvidersClicked = 'Provider Assignment Search For Providers Clicked',
  providerAssignmentEndAssignmentKebabMenuClicked = 'Provider Assignment End Assignment Kebab Menu Clicked',
  providerAssignmentUndoButtonClicked = 'Provider Assignment Undo Button Clicked',
  providerAssignmentVoidAssignmentKebabMenuClicked = 'Provider Assignment Void Assignment Kebab Menu Clicked',
  providerAssignmentVoidAssignmentCancelButtonClicked = 'Provider Assignment Void Assignment Cancel Button Clicked',
  providerAssignmentVoidAssignmentConfirmButtonClicked = 'Provider Assignment Void Assignment Confirm Button Clicked',
  providerAssignmentVoidAssignmentModalCloseButtonClicked = 'Provider Assignment Void Assignment Modal Close Button Clicked',
  providerAssignmentVoidReasonSelected = 'Provider Assignment Void Reason Selected',
  providerAssignmentAddTeamButtonClicked = 'Provider Assignment Add Team Button Clicked',
  providerAssignmentEditTeamButtonClicked = 'Provider Assignment Edit Team Button Clicked',
  collapseSessionGuideDrawer = 'Collapse Session Guide Drawer',
  expandSessionGuideDrawer = 'Expand Session Guide Drawer',
  patientStatusHeaderHovered = 'Patient Status Header Hovered',
  reassignmentStartClick = 'Reassignment Start Click',
  reassignmentDateEdit = 'Reassignment Date Edit',
  reassignmentVoidClick = 'Reassignment Void Click',
  reassignmentVoidSubmission = 'Reassignment Void Submission',
  reassignmentSubmission = 'Reassignment Submission',
  reassignmentAbandoned = 'Reassignment Abandoned',
}

export enum PatientClinicalEvents {
  bannerOrderScaleClicked = 'Banner Order Scale Clicked',
  deviceCardOrderScaleClicked = 'Device Card Order Scale Clicked',
  bannerWarningConfirmationModalUnderEighteenProceedWithOrderClicked = 'Banner Warning ConfirmationModal Under Eighteen Proceed With Order Clicked',
  bannerWarningConfirmationModalNoWeightDataProceedWithOrderClicked = 'Banner Warning Confirmation Modal No Weight Data Proceed With Order Clicked',
  bannerWarningConfirmationModalExceedsWeightProceedWithOrderClicked = 'Banner Warning Confirmation Modal Exceeds Weight Proceed With Order Clicked',
  deviceWarningConfirmationModalUnderEighteenProceedWithOrderClicked = 'Device Card Warning Confirmation Modal Under Eighteen Proceed With Order Clicked',
  deviceWarningConfirmationModalNoWeightDataProceedWithOrderClicked = 'Device Card Warning Confirmation Modal No Weight Data Proceed With Order Clicked',
  deviceWarningConfirmationModalExceedsWeightProceedWithOrderClicked = 'Device Card Warning Confirmation Modal Exceeds Weight Proceed With Order Clicked',
  bannerShippingAddressConfirmationModalUseThisAddressClicked = 'Banner Shipping Address Confirmation Modal Use This Address Clicked',
  deviceShippingAddressConfirmationModalUseThisAddressClicked = 'Device Card Shipping Address Confirmation Modal Use This Address Clicked',
  bannerShippingAddressConfirmationModalEnterAddressManuallyClicked = 'Banner Shipping Address Confirmation Modal Enter Address Manually Clicked',
  deviceShippingAddressConfirmationModalEnterAddressManuallyClicked = 'Device Shipping Address Confirmation Modal Enter Address Manually Clicked',
  bannerEnterAddressManuallyModalUseThisAddressClicked = 'Banner Enter Address Manually Modal Use This Address Clicked',
  deviceEnterAddressManuallyModalUseThisAddressClicked = 'Device Card Enter Address Manually Modal Use This Address Clicked',
  bannerEnterAddressManuallyModalBackClicked = 'Banner Enter Address Manually Modal Back Clicked',
  deviceEnterAddressManuallyModalBackClicked = 'Device Card Enter Address Manually Modal Back Clicked',
  bannerReviewAndConfirmOrderModalConfirmOrderClicked = 'Banner Review And Confirm Order Modal Confirm Order Clicked',
  deviceReviewAndConfirmOrderModalConfirmOrderClicked = 'Device Card Review And Confirm Order Modal Confirm Order Clicked',
  bannerReviewAndConfirmOrderModalBackClicked = 'Banner Review And Confirm Order Modal Back Clicked',
  deviceReviewAndConfirmOrderModalBackClicked = 'Device Card Review And Confirm Order Modal Back Clicked',
  deviceCardClicked = 'Device Card Clicked',
  trackingIdClicked = 'Tracking Id Clicked',
  viewInstructionsClicked = 'View Instructions Clicked',
  equipScaleDeviceCardKebabMenuClicked = 'Equip Scale Device Card Kebab Menu Clicked',
  equipScaleReorderScaleMenuOptionClicked = 'Equip Scale Reorder Scale Menu Option Clicked',
  equipScaleReorderReasonDropdownClicked = 'Equip Scale Reorder Reason Dropdown Clicked',
  equipScaleReorderReasonOptionSelected = 'Equip Scale Reorder Reason Option Selected',
  equipScaleReorderContinueButtonClicked = 'Equip Scale Reorder Continue Button Clicked',
  equipScaleReorderCancelButtonClicked = 'Equip Scale Reorder Cancel Button Clicked',
}
export enum PatientScheduleAppointmentEvents {
  appointmentTypeSelected = 'Appointment Type Selected',
  ignoreAvailabilitySettingsToggled = 'Ignore Availability Settings Toggled',
  makeHostKebabMenuButtonClicked = 'Make Host Kebab Menu Button Clicked',
  changeHostConfirmationModalChangeHostButtonClicked = 'Change Host Confirmation Modal Change Host Button Clicked',
  scheduleAppointmentModalContinueButtonClicked = 'Schedule Appointment Modal Continue Button Clicked',
  scheduleAppointmentModalScheduleAppointmentButtonClicked = 'Schedule Appointment Modal Schedule Appointment Button Clicked',
  newProviderSelectedFromSearch = 'New Provider Selected From Search',
  scheduleAppointmentModalAppointmentSelectionView = 'Schedule Appointment Modal Appointment Selection View',
  scheduleAppointmentModalAppointmentConfirmationView = 'Schedule Appointment Modal Appointment Confirmation View',
}

export enum EditAppointmentEvents {
  editAppointmentDiscardChangesCTAClicked = 'Edit appointment discard changes CTA clicked',
  editBackCTAClicked = 'Back CTA clicked',
  editContinueCTAClicked = 'Continue CTA clicked',
  editAppointmentClicked = 'Edit appointment clicked',
  editAppointmentCTAClicked = 'Edit appointment CTA clicked',
  editSaveChangesCTAClicked = 'Save changes CTA clicked',
  nextOrLastDayWithEventsClicked = 'Next/Last day with events clicked',
}

export enum AppointmentCancellationEvents {
  cancellationReasonSelectionClicked = 'Cancellation reason selection clicked',
  cancellationAdditionalReasonSelectionClicked = 'Cancellation additional reason selection clicked',
  cancelAppointmentCTAClicked = 'Appointment cancelled',
  xClicked = 'X clicked',
  cancelAppointmentKebabMenuClicked = 'Cancel appointment clicked',
  seriesSelectionClicked = 'Series selection clicked',
}

export enum AppointmentCancellationSource {
  singleAppointmentCancellationScreen = 'Single appointment cancellation screen',
  recurringAppointmentCancellationScreen = 'Recurring appointment cancellation screen',
  dailyViewCard = 'Daily view card',
  dailyViewAppointmentDetailsModal = 'Daily view appointment details modal',
  weeklyViewAppointmentDetailsModal = 'Weekly view appointment details modal',
}

export enum EditAppointmentSource {
  patientCalendarTab = 'Patient calendar tab',
  providerCalendarTab = 'Provider calendar tab',
  editRecurrenceSelectionScreen = 'Edit recurrence selection screen',
  editAvailabilitySelectionScreen = 'Edit availability selection screen',
  editAppointmentReviewDetailsScreen = 'Edit appointment review details screen',
}

export interface PatientEventsProps extends Record<string, unknown> {
  patientId: string;
  source?:
    | AnalyticsSourceValues.CLINICAL_PROFILE_TAB
    | AnalyticsSourceValues.CARE_PLAN_TAB
    | AnalyticsSourceValues.PATIENT_TAB
    | AnalyticsSourceValues.CALENDAR_TAB
    | AnalyticsSourceValues.DOCUMENTS_TAB
    | AnalyticsSourceValues.TASKS_TAB
    | AnalyticsSourceValues.PATIENT_CALENDAR_TAB
    | AnalyticsSourceValues.SCHEDULE_APPOINTMENT_MODAL
    | AnalyticsSourceValues.LABS_TAB;
}
